//@flow

export const getAccountNumber = (win: WindowProxy) : ?string  => (win.document.cookie.match(/reece-account-number=([^;]+)*/) && win.document.cookie.match(/reece-account-number=([^;]+)*/)[1]) || undefined;

export const isMaxUser = (win: WindowProxy) : boolean => win.document.querySelector("[data-user-type='MAX_USER']");

export const toHTMLElement = (elem: ?HTMLElement) : HTMLElement => (((elem):any):HTMLElement);

export const getUserPostCode = (win: WindowProxy) : ?string => {
  const searchDiv : HTMLElement = win.document.querySelector("[data-user-postcode]");
  if (searchDiv) {
    return searchDiv.dataset.userPostcode;
  }
  return undefined;
};

export const getCustomerSegment = (win: WindowProxy = window) : string => {
    const el = win.document.querySelector("[data-user-type]");
    switch (el && el.getAttribute("data-user-type")) {
        case "RETAIL_USER":         return "Retail";
        case "ANONYMOUS_USER":      return "Anonymous";
        case "UNLINKED_TRADE_USER": return "Retail";
        case "MAX_USER":            return "Max";
        default:                    return "Max";
    }
};
